import React from 'react'
import ReportHeader from '../../../common/ReportHeader'
import { Box } from '@mui/material'
import LinkPlaceConfigFilters from './LinkPlaceConfigFilters'
import { useDispatch } from 'react-redux'
import { masterConfigMenuVSBL } from '../../../../redux/Actions'
const EditLinkPlaceConfig = (props) => {
  const dispatch=useDispatch()
  const { handleEdits, data, getTableData } = props
  return (
    <Box className='masterConfig_container'>
      <ReportHeader headerName={'Link Place Configuration'} subHeader={"Edit Link Place"} mainHeaderName="Master Configuration" openSubMenu={() => dispatch(masterConfigMenuVSBL(true))} fixedTopPosition={true} />
      <LinkPlaceConfigFilters handleBack={handleEdits} data={data} isEdit={true} getTableData={getTableData}/>
    </Box>
  )
}

export default EditLinkPlaceConfig
